import domReady from '@wordpress/dom-ready';

// Matches the fade/scale transition the theme defines on `dialog` in
// sharedClientStyles.scss, and the shared Dialog helper's own timing.
const CLOSE_ANIMATION_MS = 300;

function setupCard(card) {
  const trigger = card.querySelector('.video-card-trigger');
  const dialog = card.querySelector('dialog.video-modal');
  const body = card.querySelector('.video-modal-body');
  const closeButton = card.querySelector('.dialog-close');
  const template = card.querySelector('template.video-card-embed');

  if (!trigger || !dialog || !body || !closeButton || !template) {
    return;
  }

  let closeTimer = null;

  const open = () => {
    window.clearTimeout(closeTimer);
    body.replaceChildren(template.content.cloneNode(true));

    // showModal() promotes the dialog to the top layer, so it escapes the
    // overflow clipping of the h-scroll track it sits inside.
    dialog.showModal();

    // The theme paints `dialog` at opacity 0 and reveals it with this class.
    dialog.classList.remove('dialog--closing');
    dialog.classList.add('dialog--opening');

    closeButton.focus();
  };

  const close = () => {
    if (!dialog.open) {
      return;
    }

    // Destroy the iframe straight away so audio stops now, not after the fade.
    body.replaceChildren();

    dialog.classList.remove('dialog--opening');
    dialog.classList.add('dialog--closing');

    closeTimer = window.setTimeout(() => {
      dialog.close();
      dialog.classList.remove('dialog--closing');
    }, CLOSE_ANIMATION_MS);
  };

  trigger.addEventListener('click', open);
  closeButton.addEventListener('click', close);

  // Escape fires `cancel`; letting it through would close the dialog without
  // emptying it, leaving the video playing.
  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    close();
  });

  // A backdrop click targets the dialog itself, anything inside targets a
  // descendant — more reliable than measuring the content box.
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      close();
    }
  });

  dialog.addEventListener('close', () => {
    trigger.focus();
  });
}

domReady(() => {
  document
    .querySelectorAll('.wp-block-improntad-theme-blocks-video-card')
    .forEach(setupCard);
});
